export default __webpack_public_path__ + "images/waves_c745ec.svg";